import linkedinIcon from '../../../img/successStories/linkedin.svg';

const TestimonialCard = ({ title, quote, name, role, company, companyLogo, avatar }) => (
  <div className="flex flex-col items-start gap-2 w-full bg-white border border-[#CBD5E1] rounded-xl p-5">
    <span className="font-gilroy-bold text-[24px] leading-[30px] tracking-[0.02em] text-[#4659CA]">
      {title}
    </span>
    <div className="w-full border-t border-[#CBD5E1]" />
    <p className="font-[Gilroy-Regular] text-[14px] leading-[18px] tracking-[0.02em] text-[#191D23]">
      {quote}
    </p>
    <div className="flex items-center gap-3 w-full pt-1">
      <div
        className="w-[52px] h-[52px] rounded-full bg-[#E1E7F8] shrink-0 bg-cover bg-center"
        style={avatar ? { backgroundImage: `url(${avatar})` } : undefined}
      />
      <div className="flex items-start justify-between flex-1 gap-2">
        <div className="flex flex-col gap-1">
          <span className="font-gilroy-bold text-[16px] leading-[22px] tracking-[0.02em] text-[#191D23]">
            {name}
          </span>
          <div className="flex items-center gap-2">
            <span className="font-gilroy-bold text-[16px] leading-[22px] tracking-[0.02em] text-[#191D23]">
              {role}
            </span>
            {companyLogo ? (
              <img src={companyLogo} alt={company} className="h-5 object-contain" />
            ) : (
              <span className="font-gilroy-bold text-[14px] leading-[22px] text-[#191D23]">{company}</span>
            )}
          </div>
        </div>
        <img src={linkedinIcon} alt="LinkedIn" className="w-6 h-6 shrink-0" />
      </div>
    </div>
  </div>
);

export default TestimonialCard;
